const MiB = 2 ** 20;
/**
 * The most writes we can do in a single transaction
 *
 * @see https://firebase.google.com/docs/firestore/quotas#writes_and_transactions
 */
export const MaxItemsPerBatch = 500;
/**
 * In production only (emulator does not use indexes)
 *   Maximum data + indexes size: 10 MiB
 *   Because: https://firebase.google.com/docs/firestore/quotas#:~:text=Maximum%20API%20request%20size
 *
 * So this doesn't really apply there. MaxDataAndIndexesSize / MaxItemsPerBatch is about 21KiB
 */
export const MaxDataAndIndexesSize = 10 * MiB;
/**
 * In emulator only:
 *   Maximum API request size: 4 MiB
 *   Because: on "CANCELLED: Call cancelled", see firestore-debug.log: io.grpc.StatusRuntimeException: RESOURCE_EXHAUSTED: gRPC message exceeds maximum size 4194304: X
 *
 * MaxEmulatorPayloadSize / MaxItemsPerBatch is about 9KiB
 */
export const MaxEmulatorPayloadSize = 4 * MiB;
//# sourceMappingURL=constants.js.map